import React from "react";
import { Skeleton, Stack } from "@mui/material";

export const InputSkeleton = ({
  hideLabel = false,
  labelHeight = 16.5,
  inputHeight = 36,
  gap="7px",
  sx = {},
}) => {
  const props = { variant: "rounded" };
  return (
    <Stack gap={gap} width="100%" sx={sx}>
      {!hideLabel && <Skeleton height={labelHeight} {...props} />}
      <Skeleton height={inputHeight} {...props} />
    </Stack>
  );
};

export default InputSkeleton;
